import styled from 'styled-components';

export const Thumb = styled.div<{ checked: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 20px;
  background-color: ${({ theme: { color }, checked }) => (checked ? color.s1 : color.ui3)};
  ${({ theme: { transition } }) => transition.default};

  position: absolute;
  left: ${({ checked }) => (checked ? 'calc(100% - 16px)' : '4px')};
  top: 50%;
  transform: translateY(-50%);
`;

export const Container = styled.div<{ isDisabled?: boolean }>`
  position: relative;
  height: 20px;
  width: 44px;
  border-radius: 10px;
  padding: 4px;
  box-sizing: border-box;
  border: 1px solid ${({ theme: { color } }) => color.ui4};
  background-color: ${({ theme: { color } }) => color.ui5};
  cursor: pointer;
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
  visibility: ${({ isDisabled }) => (isDisabled ? 'hidden' : 'visible')};

  &:hover ${Thumb} {
    background-color: ${({ theme: { color } }) => color.s2};
    box-shadow: 0px 0px 2px #7142ff;
  }
`;

export const InvisibleInput = styled.input`
  display: none;
`;
